import React from 'react';
import { Container } from 'react-bootstrap';

const LoadingSpinner = () => {
  return (
    <Container className="text-center py-5">
      <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3 text-muted">Loading content...</p>
    </Container>
  );
};

export default LoadingSpinner;
